<!-- eslint-disable vue/multi-word-component-names -->

<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-app>
    <!-- Top Navigation Bar -->
    <v-app-bar :color="colors.primaryDark" dark elevation="4" height="60">
      <div class="d-flex align-center">
        <v-icon size="40" class="ml-7 mr-2 pulse">fas fa-building</v-icon>
        <span class="text-h6 font-weight-bold gradient-text">
          {{ title }}
        </span>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center" style="gap: 24px">
        <!-- User Profile -->
        <div class="d-flex align-center mr-12 user-profile" style="gap: 7px">
          <v-avatar size="40" :color="colors.primaryLight" class="profile-avatar">
            <v-icon color="white" size="20">fas fa-user</v-icon>
          </v-avatar>
          <div class="d-flex flex-column">
            <span class="font-weight-bold text-body-2">
              {{ userDetails?.name || 'Carregando...' }}
            </span>
            <span class="text-caption opacity-75">
              {{ userDetails?.department?.name || 'Online' }}
            </span>
          </div>
        </div>
      </div>
    </v-app-bar>

    <!-- Sidebar Navigation -->
    <v-navigation-drawer
      v-model="drawer"
      :color="colors.primaryDark"
      dark
      permanent
      width="250"
      class="custom-drawer"
    >
      <!-- User Profile in Sidebar -->
      <div class="pa-4 sidebar-profile" style="border-bottom: 1px solid #1a4b7a">
        <div class="d-flex align-center" style="gap: 12px">
          <v-avatar size="45" :color="colors.primaryLight" class="profile-avatar">
            <v-icon color="white" size="22">fas fa-user</v-icon>
          </v-avatar>
          <div>
            <div class="font-weight-bold text-body-2 lowercase">
              {{ userDetails?.name || 'Carregando...' }}
            </div>
            <div class="text-caption opacity-75">
              {{ userDetails?.department?.name || 'Sistema Online' }}
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Menu -->
      <v-list nav class="pa-0 text-start">
        <v-list-item
          v-for="item in finalMenuItems"
          :key="item.title"
          :value="item.value"
          :active="item.active"
          rounded="xl"
          class="mb-2 menu-item"
          :class="item.active ? 'active-item' : ''"
          lines="one"
          density="comfortable"
          @click="handleMenuClick(item)"
        >
          <template #prepend>
            <v-icon size="22" class="mr-2">{{ item.icon }}</v-icon>
          </template>

          <template #title>
            <span class="item-title">{{ item.title }}</span>
          </template>

          <template #append v-if="item.badge">
            <v-chip size="small" :color="item.badgeColor" class="pulse-badge">
              {{ item.badge }}
            </v-chip>
          </template>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-3" style="border-top: 1px solid #1a4b7a">
          <v-btn
            block
            variant="outlined"
            prepend-icon="fas fa-sign-out-alt"
            class="logout-btn"
            @click="logout"
          >
            Sair
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- Main Content with Tabs -->
    <v-main class="bg-grey-lighten-5 main-content" style="margin-top: 20px">
      <div class="content-wrapper">
        <!-- Page Header -->
        <div class="page-header mb-6">
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon :color="colors.primaryLight" size="36" class="mr-3">
                {{ activeTab === 0 ? 'fas fa-exchange-alt' : 'fas fa-robot' }}
              </v-icon>
              <div>
                <h1 class="text-h4 font-weight-bold text-primary mb-0">
                  {{ activeTab === 0 ? 'Gerenciador de Transferências' : 'Conversas IA' }}
                </h1>
                <p class="text-subtitle-1 text-grey-darken-1 mb-0">
                  {{ activeTab === 0 
                    ? 'Gerencie e monitore todas as transferências de conversas' 
                    : 'Gerencie o acesso da IA às conversas' }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <v-tabs
          v-model="activeTab"
          :bg-color="colors.primaryDark"
          dark
          class="mb-6"
        >
          <v-tab :value="0">
            <v-icon class="mr-2">fas fa-exchange-alt</v-icon>
            Transferências
          </v-tab>
          <v-tab :value="1">
            <v-icon class="mr-2">fas fa-robot</v-icon>
            Conversas IA
          </v-tab>
        </v-tabs>

        <!-- Tab Contents -->
        <v-window v-model="activeTab">
          <!-- Transfers Tab -->
          <v-window-item :value="0">
            <div class="transfer-manager">
              <!-- Filters and Search -->
              <v-card class="mb-4" elevation="2">
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchQuery"
                        prepend-inner-icon="fas fa-search"
                        label="Pesquisar transferências..."
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-select
                        v-model="statusFilter"
                        :items="statusOptions"
                        item-title="title"
                        item-value="value"
                        label="Status"
                        variant="outlined"
                        density="compact"
                        hide-details
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-select
                        v-model="departmentFilter"
                        :items="departmentOptions"
                        item-title="title"
                        item-value="value"
                        label="Departamento"
                        variant="outlined"
                        density="compact"
                        hide-details
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-select
                        v-model="dateFilter"
                        :items="dateOptions"
                        item-title="title"
                        item-value="value"
                        label="Período"
                        variant="outlined"
                        density="compact"
                        hide-details
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-btn
                        :color="colors.primaryLight"
                        variant="flat"
                        block
                        prepend-icon="fas fa-sync"
                        @click="fetchTransfers"
                        :loading="loading"
                      >
                        Atualizar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Transfers Table -->
              <v-card elevation="2">
                <v-card-title class="d-flex align-center pa-4">
                  <v-icon class="mr-2" :color="colors.primaryDark">fas fa-list</v-icon>
                  <span>Lista de Transferências</span>
                  <v-spacer />
                  <v-chip :color="colors.primaryLight" variant="flat">
                    {{ filteredTransfers.length }} transferências
                  </v-chip>
                </v-card-title>

                <v-divider />

                <!-- Loading State -->
                <div v-if="loading" class="pa-8 text-center">
                  <v-progress-circular
                    :color="colors.primaryLight"
                    indeterminate
                    size="64"
                  />
                  <p class="mt-4 text-grey">Carregando transferências...</p>
                </div>

                <!-- Error State -->
                <div v-else-if="error" class="pa-8 text-center">
                  <v-icon size="64" color="error" class="mb-4">fas fa-exclamation-triangle</v-icon>
                  <p class="text-h6 text-error mb-2">Erro ao carregar dados</p>
                  <p class="text-grey mb-4">{{ error }}</p>
                  <v-btn :color="colors.primaryLight" @click="fetchTransfers">
                    Tentar novamente
                  </v-btn>
                </div>

                <!-- Empty State -->
                <div v-else-if="filteredTransfers.length === 0" class="pa-8 text-center">
                  <v-icon size="64" color="grey" class="mb-4">fas fa-inbox</v-icon>
                  <p class="text-h6 text-grey mb-2">Nenhuma transferência encontrada</p>
                  <p class="text-grey">Tente ajustar os filtros ou aguarde novas transferências.</p>
                </div>

                <!-- Transfers List -->
                <div v-else>
                  <v-data-table
                    :items="filteredTransfers"
                    :headers="tableHeaders"
                    :items-per-page="15"
                    class="elevation-0"
                    :loading="loading"
                  >
                    <!-- Conversation Name -->
                    <template #item.conversationName="{ item }">
                      <div class="d-flex align-center">
                        <v-avatar size="32" class="mr-3">
                          <v-img
                            v-if="item.conversationData?.avatar"
                            :src="item.conversationData.avatar"
                            :alt="item.conversationName"
                          />
                          <v-icon v-else size="16" color="grey">fas fa-user</v-icon>
                        </v-avatar>
                        <div>
                          <div class="font-weight-medium">
                            {{ item.conversationName || item.remoteJid }}
                          </div>
                          <div class="text-caption text-grey">
                            {{ formatPhoneNumber(item.remoteJid) }}
                          </div>
                        </div>
                      </div>
                    </template>

                    <!-- From User -->
                    <template #item.fromUser="{ item }">
                      <div v-if="item.fromUser">
                        <div class="font-weight-medium">{{ item.fromUser.name }}</div>
                        <div class="text-caption text-grey">{{ item.fromUser.email }}</div>
                      </div>
                      <span v-else class="text-grey">Sistema</span>
                    </template>

                    <!-- To User/Department -->
                    <template #item.destination="{ item }">
                      <v-chip
                        v-if="item.toUser"
                        :color="colors.primaryLight"
                        variant="flat"
                        size="small"
                        prepend-icon="fas fa-user"
                      >
                        {{ item.toUser.name }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.toDepartment"
                        :color="colors.primaryGreen"
                        variant="flat"
                        size="small"
                        prepend-icon="fas fa-building"
                      >
                        {{ item.toDepartment.name }}
                      </v-chip>
                      <span v-else class="text-grey">Não definido</span>
                    </template>

                    <!-- Status -->
                    <template #item.status="{ item }">
                      <v-chip
                        :color="getStatusColor(item.status)"
                        variant="flat"
                        size="small"
                        :prepend-icon="getStatusIcon(item.status)"
                      >
                        {{ getStatusText(item.status) }}
                      </v-chip>
                    </template>

                    <!-- Date -->
                    <template #item.createdAt="{ item }">
                      <div>
                        <div class="font-weight-medium">
                          {{ formatDate(item.createdAt) }}
                        </div>
                        <div class="text-caption text-grey">
                          {{ formatTime(item.createdAt) }}
                        </div>
                      </div>
                    </template>

                    <!-- Actions -->
                    <template #item.actions="{ item }">
                      <div class="d-flex gap-1">
                        <v-tooltip text="Ver detalhes">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              variant="text"
                              size="small"
                              :color="colors.primaryLight"
                              @click="viewTransferDetails(item)"
                            >
                              <v-icon size="16">fas fa-eye</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>

                        <v-tooltip text="Reverter transferência">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              variant="text"
                              size="small"
                              color="warning"
                              @click="confirmRevertTransfer(item)"
                              :disabled="item.status !== 'COMPLETED'"
                            >
                              <v-icon size="16">fas fa-undo</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>

                        <v-tooltip text="Excluir registro">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              variant="text"
                              size="small"
                              color="error"
                              @click="confirmDeleteTransfer(item)"
                            >
                              <v-icon size="16">fas fa-trash</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </div>
          </v-window-item>

          <!-- AI Conversations Tab -->
          <v-window-item :value="1">
            <div class="ai-conversations-manager">
              <!-- Filters and Search -->
              <v-card class="mb-4" elevation="2">
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="aiSearchQuery"
                        prepend-inner-icon="fas fa-search"
                        label="Pesquisar conversas..."
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        v-model="aiBlockFilter"
                        :items="aiBlockOptions"
                        item-title="title"
                        item-value="value"
                        label="Status IA"
                        variant="outlined"
                        density="compact"
                        hide-details
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-btn
                        :color="colors.primaryLight"
                        variant="flat"
                        block
                        prepend-icon="fas fa-sync"
                        @click="fetchAIConversations"
                        :loading="aiLoading"
                      >
                        Atualizar
                      </v-btn>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-btn
                        :color="colors.primaryGreen"
                        variant="flat"
                        block
                        prepend-icon="fas fa-robot"
                        @click="bulkAIActionDialog = true"
                        :disabled="selectedAIConversations.length === 0"
                      >
                        Ações em Massa
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- AI Conversations Table -->
              <v-card elevation="2">
                <v-card-title class="d-flex align-center pa-4">
                  <v-icon class="mr-2" :color="colors.primaryDark">fas fa-comments</v-icon>
                  <span>Conversas Disponíveis</span>
                  <v-spacer />
                  <v-chip :color="colors.primaryLight" variant="flat" class="mr-2">
                    {{ filteredAIConversations.length }} conversas
                  </v-chip>
                  <v-chip :color="colors.primaryGreen" variant="flat" v-if="selectedAIConversations.length > 0">
                    {{ selectedAIConversations.length }} selecionadas
                  </v-chip>
                </v-card-title>

                <v-divider />

                <!-- Loading State -->
                <div v-if="aiLoading" class="pa-8 text-center">
                  <v-progress-circular
                    :color="colors.primaryLight"
                    indeterminate
                    size="64"
                  />
                  <p class="mt-4 text-grey">Carregando conversas...</p>
                </div>

                <!-- Error State -->
                <div v-else-if="aiError" class="pa-8 text-center">
                  <v-icon size="64" color="error" class="mb-4">fas fa-exclamation-triangle</v-icon>
                  <p class="text-h6 text-error mb-2">Erro ao carregar dados</p>
                  <p class="text-grey mb-4">{{ aiError }}</p>
                  <v-btn :color="colors.primaryLight" @click="fetchAIConversations">
                    Tentar novamente
                  </v-btn>
                </div>

                <!-- Empty State -->
                <div v-else-if="filteredAIConversations.length === 0" class="pa-8 text-center">
                  <v-icon size="64" color="grey" class="mb-4">fas fa-inbox</v-icon>
                  <p class="text-h6 text-grey mb-2">Nenhuma conversa encontrada</p>
                  <p class="text-grey">Tente ajustar os filtros ou aguarde novas conversas.</p>
                </div>

                <!-- Conversations List -->
                <div v-else>
                  <v-data-table
                    v-model="selectedAIConversations"
                    :items="filteredAIConversations"
                    :headers="aiTableHeaders"
                    :items-per-page="15"
                    class="elevation-0"
                    :loading="aiLoading"
                    show-select
                    item-value="id"
                  >
                    <!-- Contact Info -->
                    <template #item.contact="{ item }">
                      <div class="d-flex align-center">
                        <v-avatar size="36" class="mr-3">
                          <v-img
                            v-if="item.profilePicUrl"
                            :src="item.profilePicUrl"
                            :alt="item.name || item.pushName"
                          />
                          <v-icon v-else size="18" color="grey">fas fa-user</v-icon>
                        </v-avatar>
                        <div>
                          <div class="font-weight-medium">
                            {{ item.name || item.pushName || 'Sem nome' }}
                          </div>
                          <div class="text-caption text-grey">
                            {{ formatPhoneNumber(item.remoteJid) }}
                          </div>
                        </div>
                      </div>
                    </template>

                    <!-- AI Status -->
                    <template #item.aiStatus="{ item }">
                      <v-chip
                        :color="item.aiBlocked ? 'error' : 'success'"
                        variant="flat"
                        size="small"
                        :prepend-icon="item.aiBlocked ? 'fas fa-ban' : 'fas fa-check-circle'"
                      >
                        {{ item.aiBlocked ? 'IA Bloqueada' : 'IA Ativa' }}
                      </v-chip>
                    </template>

                    <!-- Blocked Info -->
                    <template #item.blockedInfo="{ item }">
                      <div v-if="item.aiBlocked && item.aiBlockedAt">
                        <div class="text-caption">
                          {{ formatDate(item.aiBlockedAt) }}
                        </div>
                        <div class="text-caption text-grey">
                          {{ formatTime(item.aiBlockedAt) }}
                        </div>
                      </div>
                      <span v-else class="text-grey">-</span>
                    </template>

                    <!-- Last Update -->
                    <template #item.updatedAt="{ item }">
                      <div>
                        <div class="text-caption">
                          {{ formatDate(item.updatedAt) }}
                        </div>
                        <div class="text-caption text-grey">
                          {{ formatTime(item.updatedAt) }}
                        </div>
                      </div>
                    </template>

                    <!-- Actions -->
                    <template #item.actions="{ item }">
                      <div class="d-flex gap-1">
                        <v-tooltip :text="item.aiBlocked ? 'Desbloquear IA' : 'Bloquear IA'">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              variant="text"
                              size="small"
                              :color="item.aiBlocked ? 'success' : 'error'"
                              @click="toggleAIBlock(item)"
                              :loading="item.loading"
                            >
                              <v-icon size="16">
                                {{ item.aiBlocked ? 'fas fa-unlock' : 'fas fa-lock' }}
                              </v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>

                        <v-tooltip text="Ver detalhes">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              variant="text"
                              size="small"
                              :color="colors.primaryLight"
                              @click="viewAIConversationDetails(item)"
                            >
                              <v-icon size="16">fas fa-eye</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>

                        <v-tooltip text="Enviar mensagem">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              variant="text"
                              size="small"
                              color="info"
                              @click="openMessageDialog(item)"
                            >
                              <v-icon size="16">fas fa-paper-plane</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </div>
          </v-window-item>
        </v-window>
      </div>

      <!-- Dialogs -->
      <!-- Transfer Details Dialog -->
      <v-dialog v-model="detailsDialog" max-width="600">
        <v-card v-if="selectedTransfer">
          <v-card-title class="d-flex align-center">
            <v-icon class="mr-2" :color="colors.primaryLight">fas fa-info-circle</v-icon>
            Detalhes da Transferência
          </v-card-title>

          <v-divider />

          <v-card-text class="pa-6">
            <v-row>
              <v-col cols="12">
                <h4 class="mb-3">Conversa</h4>
                <div class="d-flex align-center mb-4">
                  <v-avatar size="40" class="mr-3">
                    <v-img
                      v-if="selectedTransfer.conversationData?.avatar"
                      :src="selectedTransfer.conversationData.avatar"
                    />
                    <v-icon v-else>fas fa-user</v-icon>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold">{{ selectedTransfer.conversationName }}</div>
                    <div class="text-caption">{{ formatPhoneNumber(selectedTransfer.remoteJid) }}</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="6">
                <h4 class="mb-2">De:</h4>
                <p v-if="selectedTransfer.fromUser">
                  {{ selectedTransfer.fromUser.name }}<br>
                  <small class="text-grey">{{ selectedTransfer.fromUser.email }}</small>
                </p>
                <p v-else class="text-grey">Sistema</p>
              </v-col>

              <v-col cols="6">
                <h4 class="mb-2">Para:</h4>
                <p v-if="selectedTransfer.toUser">
                  <v-icon size="16" class="mr-1">fas fa-user</v-icon>
                  {{ selectedTransfer.toUser.name }}
                </p>
                <p v-else-if="selectedTransfer.toDepartment">
                  <v-icon size="16" class="mr-1">fas fa-building</v-icon>
                  {{ selectedTransfer.toDepartment.name }}
                </p>
              </v-col>

              <v-col cols="12" v-if="selectedTransfer.transferMessage">
                <h4 class="mb-2">Mensagem:</h4>
                <v-card variant="outlined" class="pa-3">
                  <p class="mb-0">{{ selectedTransfer.transferMessage }}</p>
                </v-card>
              </v-col>

              <v-col cols="6">
                <h4 class="mb-2">Status:</h4>
                <v-chip
                  :color="getStatusColor(selectedTransfer.status)"
                  variant="flat"
                  :prepend-icon="getStatusIcon(selectedTransfer.status)"
                >
                  {{ getStatusText(selectedTransfer.status) }}
                </v-chip>
              </v-col>

              <v-col cols="6">
                <h4 class="mb-2">Data:</h4>
                <p>{{ formatDateTime(selectedTransfer.createdAt) }}</p>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn variant="text" @click="detailsDialog = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- AI Conversation Details Dialog -->
      <v-dialog v-model="aiDetailsDialog" max-width="600">
        <v-card v-if="selectedAIConversation">
          <v-card-title class="d-flex align-center">
            <v-icon class="mr-2" :color="colors.primaryLight">fas fa-robot</v-icon>
            Detalhes da Conversa
          </v-card-title>

          <v-divider />

          <v-card-text class="pa-6">
            <v-row>
              <v-col cols="12">
                <div class="d-flex align-center mb-4">
                  <v-avatar size="60" class="mr-4">
                    <v-img
                      v-if="selectedAIConversation.profilePicUrl"
                      :src="selectedAIConversation.profilePicUrl"
                    />
                    <v-icon v-else size="30">fas fa-user</v-icon>
                  </v-avatar>
                  <div>
                    <h3 class="mb-1">{{ selectedAIConversation.name || selectedAIConversation.pushName || 'Sem nome' }}</h3>
                    <p class="text-body-2 mb-0">{{ formatPhoneNumber(selectedAIConversation.remoteJid) }}</p>
                  </div>
                </div>
              </v-col>

              <v-col cols="6">
                <h4 class="mb-2">Status IA:</h4>
                <v-chip
                  :color="selectedAIConversation.aiBlocked ? 'error' : 'success'"
                  variant="flat"
                  :prepend-icon="selectedAIConversation.aiBlocked ? 'fas fa-ban' : 'fas fa-check-circle'"
                >
                  {{ selectedAIConversation.aiBlocked ? 'Bloqueada' : 'Ativa' }}
                </v-chip>
              </v-col>

              <v-col cols="6">
                <h4 class="mb-2">ID da Conversa:</h4>
                <p class="text-caption">{{ selectedAIConversation.id }}</p>
              </v-col>

              <v-col cols="6" v-if="selectedAIConversation.aiBlocked">
                <h4 class="mb-2">Bloqueado em:</h4>
                <p>{{ formatDateTime(selectedAIConversation.aiBlockedAt) }}</p>
              </v-col>

              <v-col cols="6" v-if="selectedAIConversation.aiBlockedBy">
                <h4 class="mb-2">Bloqueado por:</h4>
                <p>Usuário #{{ selectedAIConversation.aiBlockedBy }}</p>
              </v-col>

              <v-col cols="6">
                <h4 class="mb-2">Criado em:</h4>
                <p>{{ formatDateTime(selectedAIConversation.createdAt) }}</p>
              </v-col>

              <v-col cols="6">
                <h4 class="mb-2">Última atualização:</h4>
                <p>{{ formatDateTime(selectedAIConversation.updatedAt) }}</p>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-btn
              :color="selectedAIConversation.aiBlocked ? 'success' : 'error'"
              variant="flat"
              @click="toggleAIBlock(selectedAIConversation); aiDetailsDialog = false"
            >
              {{ selectedAIConversation.aiBlocked ? 'Desbloquear IA' : 'Bloquear IA' }}
            </v-btn>
            <v-spacer />
            <v-btn variant="text" @click="aiDetailsDialog = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Message Dialog -->
      <v-dialog v-model="messageDialog" max-width="500">
        <v-card>
          <v-card-title class="d-flex align-center">
            <v-icon class="mr-2" color="info">fas fa-paper-plane</v-icon>
            Enviar Mensagem
          </v-card-title>

          <v-divider />

          <v-card-text class="pa-6">
            <div class="d-flex align-center mb-4" v-if="messageTarget">
              <v-avatar size="32" class="mr-3">
                <v-img
                  v-if="messageTarget.profilePicUrl"
                  :src="messageTarget.profilePicUrl"
                />
                <v-icon v-else size="16">fas fa-user</v-icon>
              </v-avatar>
              <div>
                <div class="font-weight-medium">{{ messageTarget.name || messageTarget.pushName }}</div>
                <div class="text-caption">{{ formatPhoneNumber(messageTarget.remoteJid) }}</div>
              </div>
            </div>

            <v-textarea
              v-model="messageText"
              label="Digite sua mensagem"
              variant="outlined"
              rows="4"
              counter
              maxlength="1000"
            />
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn variant="text" @click="messageDialog = false">
              Cancelar
            </v-btn>
            <v-btn
              color="info"
              variant="flat"
              :loading="sendingMessage"
              @click="sendMessage"
              :disabled="!messageText.trim()"
            >
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Bulk AI Action Dialog -->
      <v-dialog v-model="bulkAIActionDialog" max-width="500">
        <v-card>
          <v-card-title class="d-flex align-center text-warning">
            <v-icon class="mr-2" color="warning">fas fa-exclamation-triangle</v-icon>
            Ação em Massa
          </v-card-title>

          <v-divider />

          <v-card-text class="pa-6">
            <p class="text-body-1 mb-3">
              Você selecionou <strong>{{ selectedAIConversations.length }}</strong> conversas.
            </p>
            <p class="text-body-2 mb-4">
              Escolha a ação que deseja aplicar a todas as conversas selecionadas:
            </p>

            <v-radio-group v-model="bulkAction">
              <v-radio label="Bloquear IA para todas" value="block" color="error" />
              <v-radio label="Desbloquear IA para todas" value="unblock" color="success" />
            </v-radio-group>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn variant="text" @click="bulkAIActionDialog = false">
              Cancelar
            </v-btn>
            <v-btn
              :color="bulkAction === 'block' ? 'error' : 'success'"
              variant="flat"
              :loading="bulkProcessing"
              @click="executeBulkAction"
              :disabled="!bulkAction"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Dialog -->
      <v-dialog v-model="deleteDialog" max-width="500">
        <v-card>
          <v-card-title class="d-flex align-center text-error">
            <v-icon class="mr-2" color="error">fas fa-exclamation-triangle</v-icon>
            Confirmar Exclusão
          </v-card-title>

          <v-divider />

          <v-card-text class="pa-6">
            <p class="text-body-1 mb-3">
              Tem certeza que deseja excluir este registro de transferência?
            </p>
            <p class="text-body-2 text-grey">
              <strong>Atenção:</strong> Esta ação removerá a conversa de todos os usuários
              e não poderá ser desfeita. A conversa ficará sem responsável até ser
              transferida novamente.
            </p>

            <v-card variant="outlined" class="mt-4 pa-3" v-if="transferToDelete">
              <div class="d-flex align-center">
                <v-avatar size="32" class="mr-3">
                  <v-img
                    v-if="transferToDelete.conversationData?.avatar"
                    :src="transferToDelete.conversationData.avatar"
                  />
                  <v-icon v-else size="16">fas fa-user</v-icon>
                </v-avatar>
                <div>
                  <div class="font-weight-medium">{{ transferToDelete.conversationName }}</div>
                  <div class="text-caption">{{ formatDateTime(transferToDelete.createdAt) }}</div>
                </div>
              </div>
            </v-card>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn variant="text" @click="deleteDialog = false">
              Cancelar
            </v-btn>
            <v-btn
              color="error"
              variant="flat"
              :loading="deleting"
              @click="deleteTransfer"
            >
              Excluir
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Revert Dialog -->
      <v-dialog v-model="revertDialog" max-width="500">
        <v-card>
          <v-card-title class="d-flex align-center text-warning">
            <v-icon class="mr-2" color="warning">fas fa-undo</v-icon>
            Reverter Transferência
          </v-card-title>

          <v-divider />

          <v-card-text class="pa-6">
            <p class="text-body-1 mb-3">
              Deseja reverter esta transferência?
            </p>
            <p class="text-body-2 text-grey mb-4">
              A conversa retornará para o usuário/departamento original.
            </p>

            <v-card variant="outlined" class="pa-3" v-if="transferToRevert">
              <div class="d-flex align-center">
                <v-avatar size="32" class="mr-3">
                  <v-img
                    v-if="transferToRevert.conversationData?.avatar"
                    :src="transferToRevert.conversationData.avatar"
                  />
                  <v-icon v-else size="16">fas fa-user</v-icon>
                </v-avatar>
                <div>
                  <div class="font-weight-medium">{{ transferToRevert.conversationName }}</div>
                  <div class="text-caption">
                    Reverter de {{ transferToRevert.toDepartment?.name || transferToRevert.toUser?.name }}
                    para {{ transferToRevert.fromUser?.name }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn variant="text" @click="revertDialog = false">
              Cancelar
            </v-btn>
            <v-btn
              color="warning"
              variant="flat"
              :loading="reverting"
              @click="revertTransfer"
            >
              Reverter
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        location="bottom right"
      >
        {{ snackbar.message }}
        <template #actions>
          <v-btn variant="text" @click="snackbar.show = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeMount, defineProps } from "vue";
import { useRouter } from 'vue-router';
import axios from "axios";
import { useAuthStore } from '@/stores/auth';
import { menuItems as defaultMenuItems } from '@/constants/MenuItems';
import { usePermissions } from '@/composables/usePermissions';

const API_BASE = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '');

// Props
const props = defineProps({
  title: { type: String, default: 'SICON PAINEL DE CONTROLE I.A' },
  showUserProfile: { type: Boolean, default: true },
  customMenuItems: { type: Array, default: () => [] }
});

const { 
  userDetails, 
  checkPermissionAndRedirect
} = usePermissions();
const checkAccessAndInitialize = async () => {
  const hasAccess = await checkPermissionAndRedirect('transfers');
  if (!hasAccess) {
    return false; // Redireciona para /access-denied
  }
  
  // Se tem permissão, carrega o conteúdo
  isMounted.value = true;
  await fetchUserDetails();
  return true;
};
const router = useRouter();
const authStore = useAuthStore();
const token = computed(() => authStore?.token || null);

// Layout state
const drawer = ref(true);
const isMounted = ref(false);
const activeTab = ref(0);

// Menu
const finalMenuItems = computed(() => {
  return props.customMenuItems && props.customMenuItems.length > 0 ? props.customMenuItems : defaultMenuItems;
});
const handleMenuClick = (item) => {
  if (item && item.route) {
    router.push(item.route);
  }
};

// Fetch user
const fetchUserDetails = async () => {
  if (!token.value) return;
  try {
    const res = await axios.get(`${API_BASE}/me`, {
      headers: { Authorization: `Bearer ${token.value}` }
    });
    userDetails.value = res.data || null;
  } catch (err) {
    userDetails.value = null;
  }
};

const logout = () => {
  if (authStore && typeof authStore.logout === 'function') {
    authStore.logout();
  }
  router.push('/');
};

// Colors
const colors = {
  primaryDark: "#123A5D",
  primaryLight: "#57C2E3",
  primaryGreen: "#A3C940",
  lightBg: "#E7F2F9",
};

// ---------------- Transfer Manager state & logic ----------------
const transfers = ref([]);
const loading = ref(false);
const error = ref(null);
const deleting = ref(false);
const reverting = ref(false);

// Filters
const searchQuery = ref('');
const statusFilter = ref('all');
const departmentFilter = ref('all');
const dateFilter = ref('all');

// Dialogs & selections
const detailsDialog = ref(false);
const deleteDialog = ref(false);
const revertDialog = ref(false);
const selectedTransfer = ref(null);
const transferToDelete = ref(null);
const transferToRevert = ref(null);

// Snackbar
const snackbar = ref({ show: false, message: '', color: 'success', timeout: 4000 });

// Table headers
const tableHeaders = [
  { title: 'Conversa', key: 'conversationName', sortable: true, width: '250px' },
  { title: 'De', key: 'fromUser', sortable: true, width: '180px' },
  { title: 'Para', key: 'destination', sortable: false, width: '180px' },
  { title: 'Status', key: 'status', sortable: true, width: '120px' },
  { title: 'Data', key: 'createdAt', sortable: true, width: '150px' },
  { title: 'Ações', key: 'actions', sortable: false, width: '120px', align: 'center' }
];

// Options
const statusOptions = [
  { title: 'Todos', value: 'all' },
  { title: 'Concluídas', value: 'COMPLETED' },
  { title: 'Pendentes', value: 'PENDING' },
  { title: 'Rejeitadas', value: 'REJECTED' },
  { title: 'Canceladas', value: 'CANCELLED' }
];

const departmentOptions = ref([{ title: 'Todos', value: 'all' }]);

const dateOptions = [
  { title: 'Todos', value: 'all' },
  { title: 'Hoje', value: 'today' },
  { title: 'Última semana', value: 'week' },
  { title: 'Último mês', value: 'month' }
];

// ---------------- AI Conversations state & logic ----------------
const aiConversations = ref([]);
const aiLoading = ref(false);
const aiError = ref(null);
const selectedAIConversations = ref([]);
const selectedAIConversation = ref(null);
const aiDetailsDialog = ref(false);
const messageDialog = ref(false);
const messageTarget = ref(null);
const messageText = ref('');
const sendingMessage = ref(false);
const bulkAIActionDialog = ref(false);
const bulkAction = ref('');
const bulkProcessing = ref(false);

// AI Filters
const aiSearchQuery = ref('');
const aiBlockFilter = ref('all');

const aiBlockOptions = [
  { title: 'Todas', value: 'all' },
  { title: 'IA Ativa', value: 'active' },
  { title: 'IA Bloqueada', value: 'blocked' }
];

const aiTableHeaders = [
  { title: 'Contato', key: 'contact', sortable: false, width: '300px' },
  { title: 'Status IA', key: 'aiStatus', sortable: true, width: '150px' },
  { title: 'Bloqueado em', key: 'blockedInfo', sortable: true, width: '150px' },
  { title: 'Última Atualização', key: 'updatedAt', sortable: true, width: '150px' },
  { title: 'Ações', key: 'actions', sortable: false, width: '150px', align: 'center' }
];

// Computed
const filteredTransfers = computed(() => {
  let filtered = transfers.value.slice();

  if (searchQuery.value) {
    const q = searchQuery.value.toLowerCase();
    filtered = filtered.filter(t =>
      (t.conversationName && t.conversationName.toLowerCase().includes(q)) ||
      (t.remoteJid && t.remoteJid.includes(q)) ||
      (t.fromUser?.name && t.fromUser.name.toLowerCase().includes(q)) ||
      (t.toUser?.name && t.toUser.name.toLowerCase().includes(q)) ||
      (t.toDepartment?.name && t.toDepartment.name.toLowerCase().includes(q))
    );
  }

  if (statusFilter.value !== 'all') {
    filtered = filtered.filter(t => t.status === statusFilter.value);
  }

  if (departmentFilter.value !== 'all') {
    filtered = filtered.filter(t =>
      t.toDepartment?.id === departmentFilter.value ||
      t.fromUser?.departmentId === departmentFilter.value
    );
  }

  if (dateFilter.value !== 'all') {
    const now = new Date();
    const filterDate = new Date();
    switch (dateFilter.value) {
      case 'today':
        filterDate.setHours(0,0,0,0);
        break;
      case 'week':
        filterDate.setDate(now.getDate() - 7);
        break;
      case 'month':
        filterDate.setMonth(now.getMonth() - 1);
        break;
    }
    filtered = filtered.filter(t => new Date(t.createdAt) >= filterDate);
  }

  return filtered.sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt));
});

const filteredAIConversations = computed(() => {
  let filtered = aiConversations.value.slice();

  if (aiSearchQuery.value) {
    const q = aiSearchQuery.value.toLowerCase();
    filtered = filtered.filter(c =>
      (c.name && c.name.toLowerCase().includes(q)) ||
      (c.pushName && c.pushName.toLowerCase().includes(q)) ||
      (c.remoteJid && c.remoteJid.includes(q))
    );
  }

  if (aiBlockFilter.value !== 'all') {
    filtered = filtered.filter(c => {
      if (aiBlockFilter.value === 'blocked') return c.aiBlocked === true;
      if (aiBlockFilter.value === 'active') return c.aiBlocked !== true;
      return true;
    });
  }

  return filtered.sort((a,b) => new Date(b.updatedAt) - new Date(a.updatedAt));
});

// API interactions - Transfers
const fetchTransfers = async () => {
  if (!token.value) return;
  loading.value = true;
  error.value = null;
  try {
    const res = await axios.get(`${API_BASE}/transfer-marks`, {
      headers: { Authorization: `Bearer ${token.value}` }
    });
    
    // A API agora retorna um array direto, não dentro de "transfers"
    const rawTransfers = Array.isArray(res.data) ? res.data : [];
    
    // Transformar os dados para o formato esperado
    transfers.value = rawTransfers.map(t => ({
      id: t.conversationId, // Usar conversationId como ID único
      conversationName: formatPhoneNumber(t.conversationId),
      remoteJid: t.conversationId,
      fromUser: t.fromUserId ? { 
        id: t.fromUserId, 
        name: `Usuário ${t.fromUserId}`,
        email: '-'
      } : null,
      toUser: t.toUserId ? {
        id: t.toUserId,
        name: `Usuário ${t.toUserId}`
      } : null,
      toDepartment: t.departmentId ? {
        id: t.departmentId,
        name: `Departamento ${t.departmentId}`
      } : null,
      transferMessage: t.notes || '',
      status: 'COMPLETED', // Como não há status na API, definir como concluído
      createdAt: t.createdAt,
      conversationData: null
    }));

    const departments = new Map();
    rawTransfers.forEach(t => {
      if (t.departmentId) {
        departments.set(t.departmentId, { 
          title: `Departamento ${t.departmentId}`, 
          value: t.departmentId 
        });
      }
    });
    departmentOptions.value = [
      { title: 'Todos', value: 'all' }, 
      ...Array.from(departments.values())
    ];
  } catch (err) {
    console.error('Erro ao buscar transferências:', err);
    error.value = err.response?.data?.error || err.message || 'Erro ao carregar dados';
    showSnackbar('Erro ao carregar transferências', 'error');
  } finally {
    loading.value = false;
  }
};

// API interactions - AI Conversations
const toggleAIBlock = async (conversation) => {
  if (!token.value) return;
  
  conversation.loading = true;
  const wasBlocked = conversation.aiBlocked;
  
  try {
    if (wasBlocked) {
      // Unblock
      await axios.delete(`${API_BASE}/conversations/${conversation.id}/unblock-ai`, {
        headers: { 
          Authorization: `Bearer ${token.value}`,
          'x-user-id': userDetails.value?.id || '1'
        }
      });
      conversation.aiBlocked = false;
      conversation.aiBlockedAt = null;
      conversation.aiBlockedBy = null;
      showSnackbar('IA desbloqueada com sucesso', 'success');
    } else {
      // Block
      await axios.post(`${API_BASE}/conversations/${conversation.id}/block-ai`, {}, {
        headers: { 
          Authorization: `Bearer ${token.value}`,
          'x-user-id': userDetails.value?.id || '1'
        }
      });
      conversation.aiBlocked = true;
      conversation.aiBlockedAt = new Date().toISOString();
      conversation.aiBlockedBy = userDetails.value?.id || 1;
      showSnackbar('IA bloqueada com sucesso', 'success');
    }
  } catch (err) {
    console.error('Erro ao alterar status da IA:', err);
    showSnackbar(err.response?.data?.error || 'Erro ao alterar status da IA', 'error');
    // Revert on error
    conversation.aiBlocked = wasBlocked;
  } finally {
    conversation.loading = false;
  }
};

const executeBulkAction = async () => {
  if (!bulkAction.value || selectedAIConversations.value.length === 0) return;
  
  bulkProcessing.value = true;
  let processed = 0;
  let errors = 0;

  for (const convId of selectedAIConversations.value) {
    const conv = aiConversations.value.find(c => c.id === convId);
    if (!conv) continue;

    try {
      if (bulkAction.value === 'block' && !conv.aiBlocked) {
        await toggleAIBlock(conv);
        processed++;
      } else if (bulkAction.value === 'unblock' && conv.aiBlocked) {
        await toggleAIBlock(conv);
        processed++;
      }
    } catch (err) {
      errors++;
    }
  }

  bulkProcessing.value = false;
  bulkAIActionDialog.value = false;
  selectedAIConversations.value = [];
  
  if (errors > 0) {
    showSnackbar(`${processed} conversas processadas, ${errors} erros`, 'warning');
  } else {
    showSnackbar(`${processed} conversas processadas com sucesso`, 'success');
  }
};

const openMessageDialog = (conversation) => {
  messageTarget.value = conversation;
  messageText.value = '';
  messageDialog.value = true;
};

const sendMessage = async () => {
  if (!messageText.value.trim() || !messageTarget.value) return;
  
  sendingMessage.value = true;
  try {
    // Implement message sending logic here
    // This would integrate with your WhatsApp API
    showSnackbar('Mensagem enviada com sucesso', 'success');
    messageDialog.value = false;
    messageText.value = '';
  } catch (err) {
    showSnackbar('Erro ao enviar mensagem', 'error');
  } finally {
    sendingMessage.value = false;
  }
};

const viewTransferDetails = (transfer) => {
  selectedTransfer.value = transfer;
  detailsDialog.value = true;
};

const viewAIConversationDetails = (conversation) => {
  selectedAIConversation.value = conversation;
  aiDetailsDialog.value = true;
};

const confirmDeleteTransfer = (transfer) => {
  transferToDelete.value = transfer;
  deleteDialog.value = true;
};

const confirmRevertTransfer = (transfer) => {
  transferToRevert.value = transfer;
  revertDialog.value = true;
};

const deleteTransfer = async () => {
  if (!transferToDelete.value || !token.value) return;
  deleting.value = true;
  try {
    await axios.delete(`${API_BASE}/remove-transfer-mark/${transferToDelete.value.id}`, {
      headers: { Authorization: `Bearer ${token.value}` }
    });
    const idx = transfers.value.findIndex(t => t.id === transferToDelete.value.id);
    if (idx !== -1) transfers.value.splice(idx, 1);
    showSnackbar('Transferência excluída com sucesso', 'success');
    deleteDialog.value = false;
    transferToDelete.value = null;
  } catch (err) {
    console.error(err);
    showSnackbar('Erro ao excluir transferência', 'error');
  } finally {
    deleting.value = false;
  }
};

const revertTransfer = async () => {
  if (!transferToRevert.value || !token.value) return;
  reverting.value = true;
  try {
    await axios.post(`${API_BASE}/api/transfers/${transferToRevert.value.id}/revert`, {}, {
      headers: { Authorization: `Bearer ${token.value}` }
    });
    showSnackbar('Transferência revertida com sucesso', 'success');
    revertDialog.value = false;
    transferToRevert.value = null;
    await fetchTransfers();
  } catch (err) {
    console.error(err);
    showSnackbar('Erro ao reverter transferência', 'error');
  } finally {
    reverting.value = false;
  }
};

const showSnackbar = (message, color = 'success', timeout = 4000) => {
  snackbar.value = { show: true, message, color, timeout };
};

// Utilities
const statusColorMap = {
  COMPLETED: 'success',
  PENDING: 'warning',
  REJECTED: 'error',
  CANCELLED: 'grey'
};
const statusIconMap = {
  COMPLETED: 'fas fa-check-circle',
  PENDING: 'fas fa-clock',
  REJECTED: 'fas fa-times-circle',
  CANCELLED: 'fas fa-ban'
};
const statusTextMap = {
  COMPLETED: 'Concluída',
  PENDING: 'Pendente',
  REJECTED: 'Rejeitada',
  CANCELLED: 'Cancelada'
};

const getStatusColor = (s) => statusColorMap[s] || 'grey';
const getStatusIcon = (s) => statusIconMap[s] || 'fas fa-question-circle';
const getStatusText = (s) => statusTextMap[s] || s;

const formatDate = (d) => d ? new Date(d).toLocaleDateString('pt-BR') : '';
const formatTime = (d) => d ? new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '';
const formatDateTime = (d) => d ? new Date(d).toLocaleString('pt-BR') : '';
const formatPhoneNumber = (remoteJid) => {
  if (!remoteJid) return '';
  const number = remoteJid.replace(/@.*$/, '');
  if (number.length === 13 && number.startsWith('55')) {
    return `+${number.slice(0,2)} ${number.slice(2,4)} ${number.slice(4,9)}-${number.slice(9)}`;
  }
  return number;
};

// Lifecycle
onMounted(async () => {
  isMounted.value = true;
  await fetchUserDetails();
  await fetchTransfers();
  await checkAccessAndInitialize();
});

onBeforeMount(() => {
  isMounted.value = false;
});
</script>

<style scoped>
/* Animations */
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

/* Component Styles */
.gradient-text {
  background: linear-gradient(45deg, #57C2E3, #A3C940);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.pulse {
  animation: pulse 2s infinite;
}

.user-profile {
  transition: all 0.3s ease;
  border-radius: 12px;
  padding: 8px 12px;
}

.user-profile:hover {
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
}

.profile-avatar {
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.profile-avatar:hover {
  border-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.05);
}

.custom-drawer {
  background: linear-gradient(180deg, #123A5D 0%, #0f2a42 100%);
}

.menu-item {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 4px 0;
  position: relative;
  overflow: hidden;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.12) !important;
  transform: translateX(4px);
}

.active-item {
  background: linear-gradient(135deg, #57C2E3, #4aa3c1) !important;
  box-shadow: 0 4px 12px rgba(87, 194, 227, 0.3);
}

.active-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: #A3C940;
}

.pulse-badge {
  animation: pulse 2s infinite;
}

.logout-btn {
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.6);
}

.main-content {
  background: linear-gradient(135deg, #f5f5f5 0%, #e8f4f8 100%);
}

/* Transfer manager styles (merged) */
.transfer-manager {
  padding: 24px;
}

.page-header {
  background: linear-gradient(135deg, rgba(87, 194, 227, 0.1) 0%, rgba(163, 201, 64, 0.1) 100%);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid rgba(87, 194, 227, 0.2);
}

.stat-card {
  min-width: 120px;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(87, 194, 227, 0.15);
}

.text-primary {
  color: #123A5D !important;
}

/* Custom table styles */
:deep(.v-data-table) {
  border-radius: 0 0 8px 8px;
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

:deep(.v-data-table__tr:hover) {
  background: rgba(87, 194, 227, 0.05) !important;
}

/* Dialog styles */
:deep(.v-dialog .v-card) {
  border-radius: 16px;
}

:deep(.v-dialog .v-card-title) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px 16px 0 0;
  padding: 20px 24px;
  font-size: 1.25rem;
  font-weight: 600;
}

/* Status chips */
.v-chip {
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Avatar hover effect */
.v-avatar {
  transition: all 0.3s ease;
}

.v-avatar:hover {
  transform: scale(1.05);
}

/* Button animations */
.v-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-btn:hover {
  transform: translateY(-1px);
}

/* Loading and empty states */
.pa-8 {
  padding: 48px !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .transfer-manager {
    padding: 16px;
  }

  .page-header {
    padding: 16px;
  }

  .page-header .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 16px;
  }

  .stat-card {
    min-width: 100px;
  }

  .user-profile span:last-child {
    display: none;
  }
}

@media (max-width: 600px) {
  .page-header h1 {
    font-size: 1.5rem !important;
  }

  .d-flex.gap-3 {
    flex-direction: column;
    width: 100%;
  }

  .stat-card {
    min-width: auto;
  }

  .gradient-text {
    font-size: 1rem;
  }
}

.lowercase { text-transform: lowercase; }
</style>
